import React from "react";
import styled from "styled-components";
import Carousel from "react-bootstrap/Carousel";
import { CompassHeader, CompassParagraph } from "../common/styledComponents";

const StyledCarousel = styled(Carousel)`
  width: 100%;
  .carousel-indicators {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0;
  }

  .carousel-indicators [data-bs-target] {
    width: 30px;
    height: 3px;
    border-radius: 2px;
    margin-right: 5px;
    margin-left: 5px;

    background-color: #999;
  }

  .carousel-indicators .active[data-bs-target] {
    width: 50px;
    height: 5px;
    border-radius: 2px;
    background-color: #fff;
  }
`;

const StyledCarouselCaption = styled(Carousel.Caption)`
  text-align: left;
  bottom: 20px;
  width: 45%;
  left: 10px;
  top: 0%;
`;

const CarouselItemStyled = styled(Carousel.Item)`
  align-items: flex-start;
  height: auto;
  min-height: 350px;
  color: white;
`;

export const LoginCarousel = (): JSX.Element => {
  const carouselItems = [
    {
      id: 1,
      title: "ESG SAAS for Financial Institutions",
      text: "A fully vertical and horizontally integrated data and analytics system. Seamlessly integrate ESG data into your existing systems and workflows. Our platform is designed to be user-friendly and intuitive, making it easy to get started and scale up as needed",
      caption: "First slide",
    },
    {
      id: 2,
      title: "Regulatory Reporting Made Easy",
      text: "Simplify regulatory reporting, portfolio audits, and non-conforming company flagging with our ESG SAAS solution. Trigger custom workflows and track engagements effortlessly.",
      caption: "Second slide",
    },
    {
      id: 3,
      title: "Enhance ESG Impact",
      text: "Measure and improve your organization's ESG impact using our platform's analytics. Drive positive change with actionable insights and data-driven decisions.",
      caption: "Third slide",
    },
  ];

  return (
    <StyledCarousel controls={false}>
      {carouselItems.map((item) => (
        <CarouselItemStyled key={item.id} interval={5000}>
          <StyledCarouselCaption>
            <CompassHeader>{item.title}</CompassHeader>
            <CompassParagraph fontSize={17} color={"white"}>
              {item.text}
            </CompassParagraph>
          </StyledCarouselCaption>
        </CarouselItemStyled>
      ))}
    </StyledCarousel>
  );
};
